import axios from "axios";
import i18n from "../i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const lang = () => i18n.language?.startsWith("fr") ? "fr" : "en";

export const fetchProducts = async () => {
  const { data } = await axios.get(`${API}/products`, { params: { lang: lang() } });
  return data;
};

export const fetchProduct = async (slug) => {
  const { data } = await axios.get(`${API}/products/${slug}`, { params: { lang: lang() } });
  return data;
};

export const submitDemoRequest = async (payload) => {
  const { data } = await axios.post(`${API}/demo-requests`, payload);
  return data;
};
